export * from './map.module';
export * as MapBoxView from './map/map.component';